export const StatusIndicatorColor = {
  POSITIVE_CONTRAST: 'positive_contrast',
  NEGATIVE_CONTRAST: 'negative_contrast',
  ATTENTION_CONTRAST: 'attention_contrast',
  MONO_500: 'mono_500'
};